<template>
  <b-col lg="12">
    <img :src="image" :alt="alt" class="img-filter w-100"/>


    <div class="p-0">
      <slot name="p-1"/>
    </div>

  </b-col>
</template>

<script>
export default {
  name: 'C513',
  props: {
    image: {
      default: 'https://picsum.photos/200/200',
    },
    alt: {
      default: 'Mix it web',
    },

  }
};
</script>

<style scoped>
.img-filter {
  height: 150px;
  object-fit: cover;
  transition: 0.3s;
  filter: brightness(0.5);
}

.img-filter:hover {
  transition: all ease-in-out 0.3s;
  filter: none;
}
</style>
